import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AskValue from "../global/BidAsk/AskValue";
import BidValue from "../global/BidAsk/BidValue";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Tooltip } from "@mui/material";
import { MdOutlineEdit } from "react-icons/md";
import { CiMenuKebab } from "react-icons/ci";

const defaultRender = (value) => (value ? value : " ");

const formatDateTime = (dateTime) => {
    return moment(dateTime).format('DD-MM-YYYY HH:mm:ss');
};
const formatPrice = (value, decimalPlaces) => {
    if (value === null || value === undefined) return "";
    return Number(value).toFixed(decimalPlaces);
};


const usePendingOrderCell = (handleCloseClick, orderSLTP = [], onEditSLTP,handleContextMenu) => {
    const { t } = useTranslation();
    const decimalPlaces = useSelector((state) => state.user.decimalPlacesForAmountFormatting);
    const { symbols } = useSelector(state => state.watchlist)
    const getDigitsBySymbolId = (symbolId) => {
        return symbols?.[symbolId]?.digits;
    };
    const isSLTPRow = (rowId) => {
        return orderSLTP.some((order) => order.id === rowId);
    };

    return React.useMemo(() => ([
        { title: t("ticket"), dataIndex: 'id', width: 70, render: defaultRender, },
        { title: t("date/time"), dataIndex: 'dateTime', width: 140, render: (value) => formatDateTime(value), },
        {
            title: t('type'),
            dataIndex: 'side',
            width: 60,
            render: (_, row) => {
                if (row?.type !== undefined && row?.type !== null) {
                    switch (row.type) {
                        case 1: return t('BuyLimit');
                        case -1: return t('SellLimit');
                        case 2: return t('BuyStop');
                        case -2: return t('SellStop');
                        default: return '-';
                    }
                } else if (row?.side !== undefined) {
                    return row.side == 1 ? `${t('buy')} (manage)` : row.side == -1 ? `${t('sell')} (manage)` : '-';
                }
                return '-';
            }
        },

        { title: t('amount'), dataIndex: 'amount', width: 100, render: (value) => formatPrice(value, decimalPlaces), },
        { title: t('symbol'), dataIndex: 'symbolName', width: 100, render: (value, row) => symbols?.[row.symbolId]?.name || '-', },
        {
            title: t('openPrice'), dataIndex: 'price', width: 120, render: (value, row) => {
                const digits = getDigitsBySymbolId(row.symbolId);
                return value?.toFixed?.(digits);
            }
        },
        { title: t('currentPrice'), dataIndex: 'currentPrice', width: 140, render: (value, row) => row?.side == -1 ? <BidValue symbolId={row.symbolId} digits={row.digits} /> : <AskValue symbolId={row.symbolId} digits={row.digits} />, },
        {
            title: t('s/l'), dataIndex: 'stopLoss', width: 80, render: (value, row) => {
                const digits = getDigitsBySymbolId(row.symbolId);
                const displaySL = value?.toFixed?.(digits);
                return (
                    <span style={{ display: "flex", alignItems: "center", gap: 4 }}>{displaySL || ''}
                        {value != null && isSLTPRow(row.id) && (<MdOutlineEdit fontSize="small" style={{ cursor: "pointer" }} onClick={() => onEditSLTP(row)} />)}
                    </span>
                );
            }
        },
        {
            title: t('t/p'), dataIndex: 'takeProfit', width: 80, render: (value, row) => {
                const digits = getDigitsBySymbolId(row.symbolId);
                const displayTP = value?.toFixed?.(digits);
                return (
                    <span style={{ display: "flex", alignItems: "center", gap: 4 }}>{displayTP || ''}
                        {value != null && isSLTPRow(row.id) && (<MdOutlineEdit fontSize="small" style={{ cursor: "pointer" }} onClick={() => onEditSLTP(row)} />)}
                    </span>
                );
            }
        },
        { title: t("commission"), width: 100, dataIndex: "commission", render: "" },
        { title: t("swap"), width: 90, dataIndex: "interest", render: "" },
        { title: t("P/L"), width: 100, dataIndex: "profit", render: "" },
        { title: t("comment"), dataIndex: "comment", width: 100, render: defaultRender },
        {
            title: t("action"), width: 100, dataIndex: "actions", render: (value, row) => (
                <Box display="flex">
                    <Tooltip title={t('moreAction')} arrow>
                        <IconButton size="small" onClick={(event) => handleContextMenu(event, row)}>
                            <CiMenuKebab style={{ fontSize: 15 }} />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={t("cancel")} arrow><IconButton size="small" onClick={() => handleCloseClick(row?.id)}><CloseIcon sx={{ fontSize: 15 }} /></IconButton></Tooltip>
                </Box>
            )
        }

    ]));
};

export default usePendingOrderCell;
